
import { Options, Vue } from "vue-class-component";
import LabelAndValue from "@/components/general/LabelAndValue.vue";
import { globalConfig } from "@/utils";
import {
  contacts,
  getPartyClass,
  populateContactsMap,
} from "@/components/summary-panel/summary";
import { ContactType, PartyContactCorrespondent } from "@/types";
import store from "@/store";
import i18n from "@/i18n";
import { formatDate,formatAmoutswitchCurrency, formatedDate } from "@/utils/configuration/formatters-config";


@Options({
  methods: { getPartyClass },
  components: { LabelAndValue },
  props: ["organization", "manager","order", "hideClassification"],
  created() {
    if (this.organization.correspondents.length > 0) {
      populateContactsMap(
        this.organization.correspondents.find((el: PartyContactCorrespondent) => !!el)
          .contactCorrespondent
      );
    }
    store.dispatch("middleOfficeModule/searchClassification", {
      filter: {
        id: this.organization.resourceUid,
      },
      callback: this.updateResultRows,
    });
  },
})
export default class SummaryOrganization extends Vue {
  organization: any;
  manager: any;
  order?:string;
  hideClassification?: boolean;
  rows: any[] = [];
  formatDate = formatDate;
  formatedDate = formatedDate

  capitalize = globalConfig.capitalize;
  
  get offer(){
    return store.state.middleOfficeModule.offer || store.state.taskModule.offer
  }
  get offerReference(){
  return this.offer?.reference
  }
  get assignee() {
    const task = store.state.taskModule.selectedTask;
    const rawAssignee = task?.assignee || store.state.middleOfficeModule.historiesStep?.[0]?.assignee;
    if (!rawAssignee) {
      return "N/A";
    }
    return rawAssignee.includes(" ## ")
      ? rawAssignee.substring(0, rawAssignee.indexOf(" ## ")).trim()
      : rawAssignee.trim();
  }
  
  get contactType() {
    return ContactType;
  }

  get contacts() {
    return contacts;
  }

  get financialExposureTable() {
  const rawData = this.organization?.financialExposures as unknown as {
    financialInstitution: { value: string, label: string };
    outstandingType: { value: string, label: string };
    netOutstanding: number;
    grossOutstanding: number;
    residualValue: number;
    contractValidity: { until?: string, from?: string };
    contractReference: string;
  }[];

  if (!rawData || rawData.length === 0) {
    return [];
  }

  const currentDate = new Date(); // Get the current system date

  const groupedData: {
    [key: string]: {
      financialInstitution: string;
      outstandingTypes: {
        [key: string]: {
          netOutstanding: number;
          grossOutstanding: number;
          residualValue: number;
        }
      };
    }
  } = rawData.reduce((acc: any, el: any) => {
    const key = el.financialInstitution.value;
    const offerReferencePart = el.contractReference;
    
    let isValid = true;
    if (el.contractValidity && el.contractValidity.until && el.contractValidity.until.trim() !== '') {
      const contractUntilDateParts = el.contractValidity.until.split('/');
      if (contractUntilDateParts.length === 3 && 
          contractUntilDateParts[2] && 
          contractUntilDateParts[1] && 
          contractUntilDateParts[0]) {
        const contractUntilDate = new Date(
          Number(contractUntilDateParts[2]), // Year
          Number(contractUntilDateParts[1]) - 1, // Month (subtract 1 because months are zero-based)
          Number(contractUntilDateParts[0]) // Day
        );
        // Check if the contract is still valid (until date is greater than current system date)
        isValid = contractUntilDate > currentDate;
      }
    }
    
    if (isValid && offerReferencePart == this.offerReference) {
      if (!acc[key]) {
        acc[key] = {
          financialInstitution: el.financialInstitution.value,
          contractReference: el.contractReference,
          outstandingTypes: {}
        };
      }
      const outstandingTypeKey = el.outstandingType.value;
      if (!acc[key].outstandingTypes[outstandingTypeKey]) {
        acc[key].outstandingTypes[outstandingTypeKey] = {
          netOutstanding: 0,
          grossOutstanding: 0,
          residualValue: 0
        };
      }
      // Accumulate values for specific outstanding type
      acc[key].outstandingTypes[outstandingTypeKey].netOutstanding += el.netOutstanding || 0;
      acc[key].outstandingTypes[outstandingTypeKey].grossOutstanding += el.grossOutstanding || 0;
      acc[key].outstandingTypes[outstandingTypeKey].residualValue += el.residualValue || 0;
    }
    
    return acc;
  }, {});

  // Transforming data for display
  const transformedData = Object.values(groupedData).map(item => ({
    financialInstitution: i18n.global.t(
      "middleOffice.party.organization.financialInstitution." + item.financialInstitution),
    outstandingTypes: Object.entries(item.outstandingTypes).map(([key, value]) => ({
      outstandingType: i18n.global.t(
        "middleOffice.party.organization.typeOutstanding." + key),
      netOutstanding: formatAmoutswitchCurrency('EUR', value.netOutstanding),
      grossOutstanding: formatAmoutswitchCurrency('EUR', value.grossOutstanding),
      residualValue: formatAmoutswitchCurrency('EUR', value.residualValue)
    }))
  }));

  return transformedData;
}

get getDirgFromCorrespondents() {
  if (!this.organization || !Array.isArray(this.organization.correspondents)) {
    return null;
  }
  
  return this.organization.correspondents.find(
    (correspondent:any) => 
      correspondent?.qualificationType?.type?.value === "DIRG"
  );
}

  updateResultRows(rows: any) {
    this.rows = this.filterLatestValidity(rows);
  }
  filterLatestValidity(rows: any[]) {
    const latestValidityMap = new Map();
    rows.forEach(row => {
      const classTypeCode = row.class_type_code;
      if (!latestValidityMap.has(classTypeCode) ||
        row.validity_from > latestValidityMap.get(classTypeCode).validity_from ||
        (row.validity_from === latestValidityMap.get(classTypeCode).validity_from &&
         row.validity_until > latestValidityMap.get(classTypeCode).validity_until)) {
      latestValidityMap.set(classTypeCode, row);
    }
    });
    const filteredRows = Array.from(latestValidityMap.values());
    return filteredRows;
  }
 get legalCategory() {
  return store.getters["picklistModule/legalCategoryItems"].map((item: any) => {
      return {
        ...item,
        label: item.value?.toString() !== "" ?`${item.value} - ${i18n.global.t(`picklists.legal-category.${item.value}`)}` : ''
      };
    }).filter((o: any) => o.value === this.organization.legalCategory.type.value)
      .map((o: any) => o.label).join('. ');
  }

  get organizationPostalCodeCity() {
    const address =
      this.organization?.addresses?.find((el: { address?: unknown }) => !!el)?.address ||
      this.organization?.facilities?.find((f: { address?: unknown }) => f?.address)?.address;
    if (!address?.postalCode) {
      return "--";
    }
    const postal = address.postalCode.postalCode || "";
    const city = address.postalCode.city || "";
    const line = `${postal} ${city}`.trim();
    return line || "--";
  }

  get primaryBalanceSheet() {
    return this.organization?.balanceSheets?.[0];
  }

  isChiffreDAffairesDetail(detail: { nature?: { id?: string; resourceUid?: string } }) {
    const id = (detail?.nature?.id || detail?.nature?.resourceUid || "").toString().toLowerCase();
    return id.includes("chiffre") || id.includes("affaire");
  }

  get turnoverDetail() {
    const details = this.primaryBalanceSheet?.detail || [];
    return details.find((detail: { nature?: { id?: string; resourceUid?: string } }) =>
      this.isChiffreDAffairesDetail(detail)
    );
  }

  get turnoverAmount() {
    const amount = this.turnoverDetail?.value?.amount;
    if (amount === undefined || amount === null) {
      return "--";
    }
    return formatAmoutswitchCurrency("EUR", amount);
  }

  get balanceSheetDate() {
    const label = this.turnoverDetail?.label;
    if (label) {
      return label;
    }
    const from = this.primaryBalanceSheet?.period?.from;
    const until = this.primaryBalanceSheet?.period?.until;
    return from || until || "--";
  }

  get columns() {
    return globalConfig.table_config.FinancialexposureCols;
  }
  
 get managerPhoneNumber(){
  return this.organization.manager.contacts.filter((con:any) => con.contactMechanism.type?.id?.includes('PHONE_CONTACT'))[0]?.contactMechanism?.phoneNumber
 }
  valueStyle = {
    "font-weight": "bold",
    "margin-left": "20px",
    color: "black",
  };

  divValueStyle = {
    display: "flex",
    "justify-content": "end",
    "padding-right": "10px",
  };
  labelStyleItem = {
    "font-size": "1rem",
    color: "gray",
    "font-weight": "bold",
  };

  cotation(item:any):string{
    if(item.class_type_code.toLowerCase().includes('intuiz')){
      return item.id.split('-')[1]
    }
    return item.id

  }
}
